var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4373_215653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93277 4.73432L9.57544 0.5H8.71224L5.54931 4.1766L3.02308 0.5H0.109375L3.92953 6.05967L0.109375 10.5H0.972622L4.31276 6.61739L6.98065 10.5H9.89435L5.93255 4.73432H5.93277ZM4.75043 6.10865L4.36337 5.55503L1.28366 1.14984H2.60956L5.09492 4.70497L5.48198 5.25859L8.71265 9.87971H7.38675L4.75043 6.10886V6.10865Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4373_215653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.731da29b70206467cb7f3bb43fd32d49.svg";
export { ForwardRef as ReactComponent };